module.exports = __webpack_public_path__ + "static/media/Murweh.2f4cecfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Murweh.jpg
// module id = 646
// module chunks = 0